(function ($) {

  $.fn.parentDashboard = function () {
    return this;
  };

  $.fn.disableDragAndDrop = function () {
    $('main').on('drop', function() {
      return false;
    });
  };

}(jQuery));
